import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles/styles.scss';

class Countdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hours: 0,
      minutes: 0,
      seconds: 0,
      stopAnimation: false,
      intervalId: 0,
      triggerAnimation: false,
    };
  }
  componentDidMount() {
    this.getInitialTime();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  getInitialTime() {
    let hoursLeft;
    let minutesLeft;
    let secondsLeft;
    const now = new Date();

    if (!!this.props.additionalParameters.countdownEndTime) {
      const timeSet = this.props.additionalParameters.countdownEndTime;
      const newTime = new Date(timeSet);
      if (now < newTime) {
        const timeLeft = newTime.getTime() - now.getTime();
        hoursLeft = Math.floor(timeLeft / (1000 * 60 * 60));
        minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        secondsLeft = Math.floor((timeLeft % (1000 * 60)) / 1000);
      } else {
        this.setState({ stopAnimation: true });
      }
    } else {
      // Default: Count back till midnight
      hoursLeft = 23 - now.getHours();
      minutesLeft = 59 - now.getMinutes();
      secondsLeft = 59 - now.getSeconds();
    }
    if (this.state.stopAnimation === false) {
      this.setState({
        hours: hoursLeft,
        minutes: minutesLeft,
        seconds: secondsLeft,
      });
      this.countBack();
    }
  }

  countBack() {
    const intervalId = setInterval(() => {
      const { seconds, minutes, hours } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          if (hours <= 0) {
            this.setState({ stopAnimation: true });
            clearInterval(this.state.intervalId);
          } else {
            this.setState(({ hours }) => ({
              hours: hours - 1,
              minutes: 59,
            }));
          }
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
    this.setState({ intervalId });
  }

  render() {
    const { hours, minutes, seconds, stopAnimation } = this.state;

    const nextNumOne = (seconds - 1) > 0 ? seconds - 1 : 0;
    const nextNumTwo = (seconds - 2) > 2 ? seconds - 2 : 59;

    let slideOneNum = 0;
    let slideTwoNum = 0;
    let slideThreeNum = 0;


    if (seconds === 0) {
      slideOneNum = nextNumOne;
      slideTwoNum = nextNumTwo;
      slideThreeNum = seconds;
    } else if (seconds % 2 === 0) {
      slideOneNum = seconds;
      slideTwoNum = nextNumOne;
      slideThreeNum = nextNumTwo;
    } else if (seconds > 0) {
      slideOneNum = nextNumTwo;
      slideTwoNum = seconds;
      slideThreeNum = nextNumOne;
    }

    return (
      <div className="countdown">
        <div className="countdown-block">
          <span className="hours">{hours}</span>
        </div>
        <span className="divider">:</span>
        <div className="countdown-block">
          <span className="slide">
            { minutes !== undefined && `${minutes < 10 ? 0 : ''}${minutes}`}
          </span>
        </div>
        <span className="divider">:</span>
        <div className={`countdown-block seconds ${!stopAnimation ? 'animation' : ''} ${seconds % 2 === 0 ? 'animate-odd' : 'animate-even'}`}>
          <div className={`countdown-number-wrapper ${seconds % 2 === 0 ? 'animate-odd' : 'animate-even'}`}>
            <div className="slide moveout">{`${slideThreeNum < 10 ? 0 : ''}${slideThreeNum}`}</div>
            <div className="slide movein">{`${slideTwoNum < 10 ? 0 : ''}${slideTwoNum}`}</div>
            <div className="slide movein">{`${slideOneNum < 10 ? 0 : ''}${slideOneNum}`}</div>
          </div>
        </div>
      </div>
    );
  }
}

Countdown.propTypes = {
  additionalParameters: PropTypes.object,
  countdownEndTime: PropTypes.string,
};

export default Countdown;
